import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppSettings } from '../../../shared/app.settings';
import { StorageService } from './../../services/storage.service';
import { LoaderService } from './../../components/loader/loader.service';
import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { Message } from 'primeng/api';
import { UiService } from '../../services/ui.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { UserCommonService } from '../../services/user-common.service';


@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html'
})

export class ImageCropperComponent implements OnInit {
  @Input() aspectRatio = '4 / 3';
  @Input() resizeToWidth: any = 300;
  @Input() resizeToHeight: any = 300;
  @Input() cropperMinWidth: any;
  @Input() cropperMinHeight: any;
  @Input() accept;
  @Input() uploadButtonLabel;
  @Input() isChatAttachment;
  @Input() disableFile: boolean;
  @Output() fileUpload: EventEmitter<any> = new EventEmitter();
  @Output() fileUploadEvent: EventEmitter<any> = new EventEmitter();
  @Output() croppedImageEvent: EventEmitter<any> = new EventEmitter();
  maxSize = AppSettings.FILE_UPLOAD_MAX_SIZE_IN_BYTE;
  fileUploadUrl: string = AppSettings.UPLOAD_FILE_URL;
  maxSizeMessage;
  invalidFileMessage;
  message: Message[] = [];
  imageChangedEvent: any = '';
  croppedImage: any = '';
  isUploadDisabled = true;


  constructor(
    private loaderService: LoaderService,
    private uiService: UiService,
    private commonService: CommonBindingDataService,
    private userCommonService: UserCommonService) {
  }

  ngOnInit() {
    this.maxSizeMessage = this.commonService.getLabel('file_size_limit');
    this.invalidFileMessage = this.commonService.getLabel('invalid_file_type');
    if (this.isChatAttachment) {
      this.maxSize = AppSettings.FILE_UPLOAD_MAX_SIZE_IN_BYTE_FOR_MESSAGES;
      this.maxSizeMessage = this.commonService.getLabel('file_size_limit_for_messages');
    }
  }

  fileChangeEvent(event: any): void {
    this.isUploadDisabled = false;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  base64ImageToBlob(str) {
    const pos = str.indexOf(';base64,');
    const type = str.substring(5, pos);
    const b64 = str.substr(pos + 8);
    const imageContent = atob(b64);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);
    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }
    const blob = new Blob([buffer], { type: type });
    return blob;
  }

  onUploadClick() {
    const blob = <File>this.base64ImageToBlob(this.croppedImage);
    if (blob.size > 5000000) {
      this.uiService.showMessage(this.maxSizeMessage, AppSettings.MESSAGE_TYPES.ERROR);
      return;
    }
    this.onUploadImage({ files: blob });
  }

  public onUploadImage(data: { files: File }): void {
    this.loaderService.show('page-center');
    const formData: FormData = new FormData();
    const file = data.files;
    formData.append('file[]', file, 'test.png');
    this.userCommonService.image(formData).subscribe(response => {
      this.isUploadDisabled = true;
      this.loaderService.hide();
      this.imageChangedEvent = '';
      this.fileUpload.emit({ fileId: response.fileId, imageUrl: `${AppSettings.GET_FILE_URL}${response.fileId}?download=no&thumb=no` });
    });
  }
}
